import { LAYOUTS } from '@/App.vue'
import ROUTE_NAMES from './route-names'

const {
  checkout,
  checkoutRegistration,
  checkoutShipping,
  checkoutPayment,
  checkoutConfirmation,
  pageNotFound,
  product,
  npsFeedback,
  demoSizing,
  demo,
  demoForm,
  demoDyApi,
  shoeFinder,
} = ROUTE_NAMES

export default [
  {
    path: `/${checkout}`,
    name: checkout,
    meta: { layout: LAYOUTS.simple },
    component: () => {
      return import(/* webpackChunkName: "checkout-v2" */ '@/views/Checkout.vue')
    },
    children: [
      {
        path: `${checkoutRegistration}`,
        name: checkoutRegistration,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "registration" */ '@/views/Checkout/Registration.vue')
        },
      },
      {
        path: `${checkoutShipping}/:scrollAnchor?`,
        name: checkoutShipping,
        meta: { layout: LAYOUTS.simple, modifier: 'bottom-margin' },
        component: () => {
          return import(/* webpackChunkName: "shipping" */ '@/views/Checkout/Shipping.vue')
        },
        props: true,
      },
      {
        path: `${checkoutPayment}/:scrollAnchor?`,
        name: checkoutPayment,
        meta: { layout: LAYOUTS.simple, modifier: 'bottom-margin' },
        component: () => {
          return import(/* webpackChunkName: "payment" */ '@/views/Checkout/Payment.vue')
        },
        props: true,
      },
      {
        path: `${checkoutConfirmation}/:orderNumber`,
        name: checkoutConfirmation,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "confirmation" */ '@/views/Checkout/Confirmation.vue')
        },
      },
    ],
  },
  {
    path: `/${product}/:productGroup/:gender?/:colors?`,
    name: product,
    component: () => {
      return import(/* webpackChunkName: "product-page" */ '@/views/ProductPage.vue')
    },
  },
  {
    path: `/${npsFeedback}`,
    name: npsFeedback,
    component: () => {
      return import(/* webpackChunkName: "nps" */ '@/views/Nps.vue')
    },
  },
  {
    path: `/${shoeFinder}/:productGroup?`,
    name: shoeFinder,
    component: () => {
      return import(/* webpackChunkName: "shoe-finder" */ '@/views/ShoeFinder.vue')
    },
  },
  {
    path: `/${demo}`,
    component: () => {
      return import(/* webpackChunkName: "demo" */ '@/views/Demo/Demo.vue')
    },
    children: [
      {
        path: '',
        name: demo,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "demo-table-of-content" */ '@/views/Demo/DemoTableOfContent.vue')
        },
      },
      {
        path: `${demoForm}`,
        name: demoForm,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "demo-form" */ '@/views/Demo/DemoForm.vue')
        },
      },
      {
        path: `${demoSizing}`,
        name: demoSizing,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "demo-sizing" */ '@/views/Demo/DemoSizing.vue')
        },
      },
      {
        path: `${demoDyApi.replace(/^demo-/, '')}`,
        name: demoDyApi,
        meta: { layout: LAYOUTS.simple },
        component: () => {
          return import(/* webpackChunkName: "demo-dy-api" */ '@/views/Demo/DemoDyApi.vue')
        },
      },
    ],
  },
  {
    path: '*',
    name: pageNotFound,
    meta: { layout: LAYOUTS.blank },
    component: () => {
      return import(/* webpackChunkName: "page-not-found" */ '@/views/PageNotFound.vue')
    },
  },
]
